import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Spin } from "antd";
import axiosClient from "../../api/axios";
import LinkUpload from "../../api/LinkUpload";
import Marquee from "react-fast-marquee";
// Import CSS cho trang chủ
import './HomeView.css';
import HeaderBanner from "../HeaderBanner/HeaderBanner";

// =================== CÁC COMPONENT CON TÁI SỬ DỤNG ===================

const SectionHeader = ({ title, link }) => {
    const history = useHistory();
    return (
        <a href={link} onClick={(e) => { e.preventDefault(); history.push(link); }} className="section-header">
            <h2>{title}</h2>
            <span className="view-all-link">Xem tất cả →</span>
        </a>
    );
};

// =================== POSTCARD ĐÃ ĐƯỢC CẬP NHẬT ===================
const PostCard = ({ article, type = 'grid' }) => {
    const history = useHistory();
    if (!article) return null;

    const handleCardClick = (e) => {
        e.preventDefault();
        history.push(`/view/${article.Slug}`);
    };

    return (
        <a
            href={`/view/${article.Slug}`}
            

        >
            <article className={`post-card post-card--${type}`}>
                <a href={`/view/${article.Slug}`}  className="post-card__thumb">
                    {/* === THAY ĐỔI LOGIC Ở ĐÂY === */}
                    {article.ImageUrl ? (
                        <img
                            src={LinkUpload(article.ImageUrl)}
                            alt={article.Title}
                        />
                    ) : (
                        <div className="placeholder-thumbnail">
                            <i className="fa-solid fa-image"></i>
                        </div>
                    )}
                    {/* ============================= */}
                </a>
                <div className="post-card__content">
                    <h3 className="post-card__title">
                        <a href={`/view/${article.Slug}`} >
                            {article.Title}
                        </a>
                    </h3>
                    {type !== 'list' && (
                        <p className="post-card__summary">{article.Sumary}</p>
                    )}
                    <div className="post-card__meta">
                        <i className="fa-regular fa-clock"></i>
                        <span>{moment(article.PublishDate).format('DD/MM/YYYY')}</span>
                    </div>
                </div>
            </article>
        </a>
    );
};

const StatsBox = ({ memberCount, organizationCount }) => (
    <div className="stats-box">
        <h4 className="stats-box__title">Thống kê</h4>
        <div className="stats-item">
            <i className="fa-solid fa-user-tie stats-item__icon"></i>
            <a
                href={`/thanh-vien`}
            >
                <span className="stats-item__label">Luật sư thành viên:</span></a>
            <span className="stats-item__number">{memberCount}</span>
        </div>
        <div className="stats-item">
            <i className="fa-solid fa-building stats-item__icon"></i>
            <a
                href={`/to-chuc-hanh-nghe`}
            >
                <span className="stats-item__label">Tổ chức hành nghề:</span>
            </a>
            <span className="stats-item__number">{organizationCount}</span>
        </div>
    </div>
);

function Banner() {
    return (
        <div style={{
            background: "#B71C1C",
            borderRadius: "12px",
            overflow: "hidden",      // quan trọng để không leak scroll Y
        }}>
            <Marquee speed={60} gradient={false}>
                <span style={{
                    fontWeight: "bold",
                    color: "white",
                    padding: "10px 0",
                    fontSize: "28px",
                    display: "inline-block",
                    width: "100%"
                }}>
                    “ĐẠI BIỂU MẶT TRẬN TỔ QUỐC VIỆT NAM TỈNH LÂM ĐỒNG LẦN I, NHIỆM KỲ 2025 – 2030 !”
                </span>
            </Marquee>
        </div>
    );
}

// =================== COMPONENT CHÍNH CỦA TRANG CHỦ ===================
const Organization = () => {
    const token = localStorage.getItem("token");
    const header = { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${token}` };
    const [allArticles, setAllArticles] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [stats, setStats] = useState({ memberCount: 0, organizationCount: 0 });
    const [loading, setLoading] = useState(true);
    const [dataBackgrounds, setDataBackgrounds] = useState([]);
    const LoadDataBackgrounds = () => {
        axiosClient.post('/Backgrounds/GetBackgroundsAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataBackgrounds(res.data);
            }
        })
    }
    useEffect(() => {
        LoadDataBackgrounds()
        const fetchData = async () => {
            setLoading(true);
            try {
                const [articlesRes, categoriesRes, membersRes, organizationRes] = await Promise.all([
                    axiosClient.post("/Articles/GetArticlesAll", "", { headers: header }),
                    axiosClient.post("/Categories/GetCategoriesAll", "", { headers: header }),
                    axiosClient.post('/Members/GetMembersAll', {}, { headers: header }),
                    axiosClient.post('/Organizations/GetOrganizationsAll', {
                        "Name": "",
                        "Address": "",
                        "Phone": "",
                        "Email": "",
                        "Page": 1,
                        "PageSize": 100000
                    }, { headers: header }),
                ]);

                if (articlesRes.status === 200) {
                    setAllArticles(articlesRes.data.filter(a => a.Status === 1));
                }

                let orgCount = 0;
                if (categoriesRes.status === 200) {
                    const categoriesData = categoriesRes.data || [];
                    setAllCategories(categoriesData);
                    const orgCategory = categoriesData.find(cat => String(cat.Slug).includes("to-chuc-hanh-nghe"));
                    if (orgCategory && articlesRes.status === 200) {
                        orgCount = (articlesRes.data || []).filter(article => article.IDCategory === orgCategory.ID && article.Status === 1).length;
                    }
                }

                let memberCount = 0;
                let organizationCount = 0;
                if (membersRes.status === 200 && organizationRes.status === 200) {
                    memberCount = (membersRes.data || []).length;
                    organizationCount = (organizationRes.data || []).length;
                }
                setStats({ memberCount, organizationCount });
            } catch (error) {
                console.error("Lỗi khi tải dữ liệu trang chủ:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const homeSections = allCategories
        .filter(cat => ["tintuc-sukien", "thongbao", "thu-vien-tai-lieu"].includes(String(cat.Slug)))
        .sort((a, b) => a.OrderCategory - b.OrderCategory)
        .map(category => ({
            ...category,
            articles: allArticles.filter(a => a.IDCategory === category.ID).sort((a, b) => new Date(b.PublishDate) - new Date(a.PublishDate))
        }));

    const latestArticles = [...allArticles].sort((a, b) => new Date(b.PublishDate) - new Date(a.PublishDate)).slice(0, 5);
    const mainFeatured = latestArticles[0];
    const asideFeatured = latestArticles.slice(1);

    if (loading) {
        return <div style={{ textAlign: 'center', padding: '100px' }}><Spin size="large" /></div>;
    }

    return (
        <div className="container main-body">

            <main className="content-col">
                {dataBackgrounds.length > 0 && dataBackgrounds[0].IsActive === true && (
                    <div>
                        <HeaderBanner dataBackGrounds={dataBackgrounds} />
                        <br />
                    </div>
                )}


                <div className="featured-highlight-wrapper">
                    <section className="content-section">
                        <SectionHeader title="Tin mới nhất" link="/tin-moi-nhat" />
                        <div className="featured-list-layout">
                            <div className="featured-list-layout__main">
                                <PostCard article={mainFeatured} type="featured" />
                            </div>
                            <div className="featured-list-layout__aside">
                                <div className="aside-post-list">
                                    {asideFeatured.map(article => (
                                        <PostCard key={article.ID} article={article} type="list" />
                                    ))}
                                </div>
                                <StatsBox memberCount={stats.memberCount} organizationCount={stats.organizationCount} />
                            </div>
                        </div>
                    </section>
                </div>

                {homeSections.map(section => {
                    if (section.articles.length === 0) return null;
                    return (
                        <section className="content-section" key={section.ID}>
                            <SectionHeader title={section.Name} link={`/category/${section.Slug}`} />
                            <div className="category-grid-wrapper">
                                {section.articles.slice(0, 4).map(article => (
                                    <PostCard key={article.ID} article={article} type="grid" />
                                ))}
                            </div>
                        </section>
                    )
                })}
            </main>
        </div>
    );
};

export default Organization;